import { TemplateConfig } from '../types';

export const learningStatusAdviceConfig: TemplateConfig = {
  id: 'learning-status-advice',
  name: '学习状态及建议',
  description: '占卜学习状态和发展建议',
  cardCount: 4,
  
  fieldDefaults: {
    title: '学习状态及建议',
    customerQuestion: '我对自己的学习状态认知不清晰，想让自己对自己有更深入的了解和判断，以及想要看看未来自己的状态发展，想要得到在学业中的中肯建议。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 3 张牌'
    ],
    cardInfos: [
      '对学习的建议',
      '过去的情况',
      '现在的状态',
      '未来的发展'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '📚'
  }
};